import { defineComponent as W, ref as m, computed as i, watch as C, openBlock as v, createElementBlock as h, normalizeClass as s, createElementVNode as b, Fragment as j, renderList as V, normalizeStyle as E, createVNode as $, unref as P, createCommentVNode as _ } from "vue";
import { RevIllustration as F } from "@ds/components/Illustration";
import { useI18n as H } from "@ds/plugin";
import { tw as e } from "../../../utils/tailwind.js";
const M = ["aria-current", "aria-label", "onClick"], K = /* @__PURE__ */ W({
  name: "RevCarouselController",
  __name: "CarouselController",
  props: {
    buttonAriaLabelTranslation: { default: void 0 },
    currentIndex: {},
    intervalProgression: { default: 0 },
    autoplayRunning: { type: Boolean, default: !1 },
    imageCount: {},
    thumbnails: { default: () => [] },
    shouldThumbnailsScroll: { type: Boolean, default: !1 },
    prevButtonRef: { default: void 0 }
  },
  emits: ["select"],
  setup(c, { emit: R }) {
    const t = c, T = R, d = m({
      stateChanged: !1,
      iterations: 0
    });
    function r(n) {
      return n === t.currentIndex;
    }
    const f = i(
      () => t.thumbnails.length === t.imageCount
    );
    function x(n) {
      if (f.value) return e`focus-visible-outline-default-hi rounded-sm`;
      if (!t.autoplayRunning)
        return e`focus-visible-outline-default-hi rounded-sm size-8`;
      if (!r(n))
        return e`focus-visible-outline-default-hi rounded-sm relative size-8 items-center overflow-hidden`;
      const o = n === 0 && d.value.stateChanged && d.value.iterations === 0, u = n !== 0 || d.value.iterations > 0;
      return [
        e`bg-action-default-low focus-visible-outline-default-hi rounded-lg relative h-8 w-32 cursor-pointer items-center overflow-hidden
    border hover:bg-action-default-low-hover`,
        o && e`transition-width duration-300`,
        u && e`animate-fast-expand-translate-x-backwards transition-width duration-300`
      ];
    }
    function I(n) {
      if (!f.value && r(n) && t.autoplayRunning)
        return `width: ${t.intervalProgression * 100}%`;
    }
    const a = m(null), p = i(() => a.value?.children?.[t.currentIndex]), L = i(() => [
      t.shouldThumbnailsScroll && e`gradient-mask-lr-60 absolute inset-x-0`
    ]), k = i(() => (n) => {
      const o = f.value, u = r(n);
      return [
        e`appearance-none overflow-hidden no-underline transition-colors motion-reduce:transition-none`,
        !o && t.autoplayRunning && e`absolute`,
        r(n) && e`-inset-y-1 left-0`,
        !o && e`border-action-default-hi rounded-full size-8 border`,
        !o && u && e`bg-action-default-low-pressed hover:bg-action-default-low-hoverpressed`,
        !o && !u && e`bg-action-default-low hover:bg-action-default-low-hover`,
        o && e`bg-action-default-low rounded-sm flex size-40 justify-center border border-solid`,
        o && !u && e`border-action-default-mid`,
        o && u && e`border-action-default-mid-pressed`
      ];
    }), A = i(() => (n) => [
      e`flex`,
      !r(n) && e`opacity-50 hover:opacity-100 focus:opacity-100`
    ]), B = i(() => [
      e`flex list-none flex-row gap-8 overflow-hidden py-4`,
      t.shouldThumbnailsScroll ? e`justify-normal` : e`justify-center`,
      !f.value && e`-mx-4 p-4`
    ]), g = m(0), y = m(0);
    function N() {
      a.value !== null && (t.shouldThumbnailsScroll ? (g.value = t.prevButtonRef instanceof HTMLElement ? t.prevButtonRef.offsetWidth : 48, a.value.style.paddingLeft = `${g.value + 8}px`, a.value.style.paddingRight = `${g.value + 8}px`, y.value = p.value && p.value.offsetLeft + p.value.offsetWidth / 2 - a.value.offsetWidth / 2 || 0, a.value.scrollTo !== void 0 && a.value.scrollTo({
        left: y.value,
        behavior: "smooth"
      })) : (a.value.style.paddingLeft = "4px", a.value.style.paddingRight = "4px", a.value.style.marginRight = "-4px", a.value.style.marginLeft = "-4px"));
    }
    C(
      () => [t.currentIndex, t.shouldThumbnailsScroll],
      () => {
        N(), t.currentIndex === t.imageCount - 1 && (d.value.iterations += 1);
      }
    ), C(
      () => t.autoplayRunning,
      () => {
        d.value.stateChanged = !0;
      }
    );
    const z = H(), w = i(
      () => t.buttonAriaLabelTranslation
    );
    function S(n) {
      return w.value ? z(w.value, { index: n + 1 }) : "";
    }
    return (n, o) => (v(), h("div", {
      class: s(L.value)
    }, [
      b("ul", {
        ref_key: "thumbnailsRef",
        ref: a,
        class: s(B.value)
      }, [
        (v(!0), h(j, null, V(c.imageCount, (u, l) => (v(), h("li", {
          key: l,
          class: "flex"
        }, [
          b("div", {
            class: s({ "w-32": r(l) && c.autoplayRunning })
          }, [
            b("button", {
              "aria-current": r(l),
              "aria-label": S(l),
              class: s(["flex", x(l)]),
              type: "button",
              onClick: () => T("select", l)
            }, [
              b("div", {
                class: s(k.value(l)),
                style: E(I(l))
              }, [
                f.value ? (v(), h("span", {
                  key: 0,
                  class: s(A.value(l))
                }, [
                  $(P(F), {
                    alt: c.thumbnails[l].alt,
                    class: "!h-40 object-cover",
                    height: 40,
                    sizes: "40px",
                    src: c.thumbnails[l].src,
                    width: 40
                  }, null, 8, ["alt", "src"])
                ], 2)) : _("", !0)
              ], 6)
            ], 10, M)
          ], 2)
        ]))), 128))
      ], 2)
    ], 2));
  }
});
export {
  K as default
};
